<template>
    <basic-container>
        <div class="container">
            <screen-form title="老系统线路名称" @search="onSearch" @add="onAdd" :startAreaList="startAreaList"
                :oldLine="oldLine" :endAreaList="endAreaList"  @reset="onReset" />
            <line-table :records="records" :total="paginationTotal" @current="onPaginationCurrent" @delete="onDelete" />
            <line-edit-modal title="新增" :visible="dialogFormVisible" @save="saveLineConfig" :areaList="startAreaList"
                :oldLine="oldLine"></line-edit-modal>
        </div>
    </basic-container>
</template>

<script>
import ScreenForm from "./components/screen-form";
import LineTable from "./components/line-table";
import LineEditModal from "./components/line-edit";

import { to } from "@/util/util";
import { getOldLineEnum, getLineConfigEnums, getLineConfigPage, removeLineConfig, addLineConfig } from "@/api/line/line";

export default {
    components: {
        ScreenForm,
        LineTable,
        LineEditModal,
    },
    data() {
        return {
            startAreaList: [],
            oldLine: [],
            endAreaList: [],
            dialogFormVisible: false,
            // 分页
            pagination: {
                current: 1,
                size: 10,
            },
            paginationTotal: 0,
            formParams: {},
            records: [],
            saveFormParams: {}
        };
    },
    created() {
        this.initPage()
        this.getLineConfigEnumsFetch()
        this.getOldLineEnumFetch()
    },
    methods: {
        onReset(){
            this.formParams = {}
            this.pagination= {
                current: 1,
                size: 10,
            }
            this.initPage()
        },
        initPage() {
            const params = {
                // 对象结构 ... const { data, msg } = res
                ...this.pagination,
                ...this.formParams,
            }
            this.getLineConfigPageFetch(params);
        },
        // 获取选择内容
        onSearch(obj) {
            this.formParams = obj;
            this.pagination = {
                current: 1,
                size: 10,
            }
            this.initPage();
            this.dialogFormVisible = false;
        },
        // 新增
        onAdd() {
            this.dialogFormVisible = true;
            this.$forceUpdate();
        },
        //获取新增表单内容
        saveLineConfig(obj) {
            this.saveFormParams = obj
            this.saveLine()
        },

         // 保存线路配置
        saveLine(){
            this.addLineConfigFetch(this.saveFormParams);
        },
        async addLineConfigFetch(params) {
            const [err, res] = await to(addLineConfig(params));
            if (err) {
                throw err;
            }
            const { code, data, msg } = res;
            if (code !== 0) {
                this.$message.error(msg);
                return;
            }
            this.dialogFormVisible = false
            this.$message.success('保存成功！')
            this.initPage()
        },
        // 删除线路
        onDelete(id) {
            this.deleteLineConfigFetch(id)
        },
        /* 分页 */
        onPaginationCurrent(event) {
            this.pagination.current = event
            this.initPage()
        },
        /* 获取老系统线路枚举 */
        async getOldLineEnumFetch() {
            const [err, res] = await to(getOldLineEnum())
            if (err) {
                throw err
            }
            const { code, data, msg } = res
            if (code !== 0) {
                this.$message.error(msg)
                return
            }
            this.oldLine = data
        },
        /* 获取新系统出发地、目的地枚举 */
        async getLineConfigEnumsFetch() {
            const [err, res] = await to(getLineConfigEnums())
            if (err) {
                throw err
            }
            const { code, data, msg } = res
            if (code !== 0) {
                this.$message.error(msg)
                return
            }
            this.startAreaList = data
            this.endAreaList = data
        },
        /* 获取列表数据 */
        async getLineConfigPageFetch(params) {
            const [err, res] = await to(getLineConfigPage(params));
            if (err) {
                throw err;
            }
            const { code, data, msg } = res;
            if (code !== 0) {
                // this.$message.error(msg);
                return;
            }
            this.records = data.records;
            this.paginationTotal = data.total;
        },
        /* 删除线路 */
        async deleteLineConfigFetch(id) {
            const [err, res] = await to(removeLineConfig(id));
            if (err) {
                throw err;
            }
            const { code, data, msg } = res;
            if (code !== 0) {
                this.$message.error(msg);
                return;
            }
            this.initPage()
        }
    }
};
</script>

<style lang="scss" scoped>
</style>